/**
 * An article's comments (piece 30, Comments; decision 9580): what the two
 * routes answer, where they stand, and the one rule a comment is written by.
 * 🔨 No DOM here: the web's card and the phone's section both read it.
 */
import { noteIsBlank } from '../records/noteText';
import { t } from '../strings';

/** One comment as the routes answer it: its author's name and the instant it was written, drawn in the viewer's own zone. */
export interface ArticleCommentRow {
  id: string;
  authorPersonId: string;
  author: string;
  /** When the comment was written, an ISO instant. */
  at: string;
  /** A note's text under the notes' allowance: plain words, or the formatting a note keeps. */
  body: string;
}

/** The comments under one article, oldest first. 🔒 Whoever reads them may add one (decision 9580). */
export interface ArticleCommentsAnswer {
  rows: ArticleCommentRow[];
}

/** One article as the web reader and the phone open it, relative to the API root (piece 1); the web's page and the phone share it (decision 9580). */
export function articleReadPath(articleId: string): string {
  return `/knowledge/articles/${encodeURIComponent(articleId)}`;
}

/** 🔒 The comments' one route, read and added, under the article it belongs to; relative to the API root (piece 1). */
export function articleCommentsPath(articleId: string): string {
  return `/knowledge/articles/${articleId}/comments`;
}

/** 🔨 A comment is never empty: the refusal a box shows before anything is sent, and the server's own. */
export function articleCommentProblem(body: string | null | undefined): string | null {
  return noteIsBlank(body) ? t('kb.comment.empty') : null;
}
